var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#FACB1B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#FBE250"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.7636 0V2.48132C10.6598 2.48408 10.556 2.48408 10.4495 2.48408H10.4468C10.3403 2.48408 10.2392 2.48408 10.1353 2.48132V0C10.2392 0.00276009 10.3403 0.00275963 10.4468 0.00275963H10.4495C10.5586 0.00275963 10.6625 0.00276009 10.7636 0Z",
  fill: "#FDED80"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.762 20.7002V23.1815C10.6582 23.1843 10.5543 23.1843 10.4478 23.1843H10.4452C10.3387 23.1843 10.2375 23.1843 10.1337 23.1815V20.7002C10.2375 20.703 10.3387 20.703 10.4452 20.703H10.4478C10.557 20.703 10.6608 20.703 10.762 20.7002Z",
  fill: "#FDED80"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.6447 0.476328L13.0253 2.8731C12.9243 2.8479 12.824 2.82004 12.7211 2.79147L12.7186 2.79076C12.6157 2.76218 12.518 2.73504 12.4184 2.70451L13.0378 0.307739C13.1374 0.338265 13.2352 0.36541 13.338 0.393985L13.3406 0.394699C13.446 0.423988 13.5463 0.451848 13.6447 0.476328Z",
  fill: "#FDED80"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.47082 20.4749L7.85138 22.8716C7.75041 22.8464 7.65012 22.8186 7.54726 22.79L7.54469 22.7893C7.44183 22.7607 7.34411 22.7336 7.24451 22.703L7.86395 20.3063C7.96355 20.3368 8.06127 20.3639 8.16413 20.3925L8.1667 20.3932C8.27213 20.4225 8.37242 20.4504 8.47082 20.4749Z",
  fill: "#FDED80"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.3109 1.71521L15.1142 3.8641C15.0229 3.81267 14.933 3.75885 14.8408 3.70365L14.8385 3.70227C14.7463 3.64706 14.6587 3.59462 14.5701 3.53841L15.7668 1.38953C15.8553 1.44574 15.9429 1.49818 16.0352 1.55338L16.0375 1.55476C16.132 1.61134 16.2219 1.66516 16.3109 1.71521Z",
  fill: "#FDED80"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.32798 19.642L5.13131 21.7909C5.04007 21.7394 4.95015 21.6856 4.85793 21.6304L4.85563 21.629C4.7634 21.5738 4.67579 21.5214 4.58721 21.4652L5.78387 19.3163C5.87246 19.3725 5.96007 19.4249 6.05229 19.4801L6.0546 19.4815C6.14912 19.5381 6.23904 19.5919 6.32798 19.642Z",
  fill: "#FDED80"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.5774 3.62514L16.8851 5.3797C16.8098 5.30554 16.7364 5.22942 16.6611 5.15136L16.6592 5.14941C16.5839 5.07134 16.5124 4.99718 16.4408 4.91911L18.1332 3.16455C18.2047 3.24262 18.2762 3.31678 18.3515 3.39485L18.3534 3.3968C18.4306 3.47682 18.504 3.55293 18.5774 3.62514Z",
  fill: "#FDED80"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.45665 18.263L2.76431 20.0175C2.68901 19.9434 2.61559 19.8672 2.5403 19.7892L2.53841 19.7872C2.46311 19.7092 2.39158 19.635 2.32005 19.5569L4.01239 17.8024C4.08392 17.8804 4.15546 17.9546 4.23076 18.0327L4.23264 18.0346C4.30982 18.1146 4.38323 18.1907 4.45665 18.263Z",
  fill: "#FDED80"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.12916 1.38855L6.32582 3.53743C6.23724 3.59364 6.14732 3.64746 6.0551 3.70266L6.05279 3.70405C5.96057 3.75925 5.87296 3.81169 5.78172 3.86312L4.58505 1.71423C4.6763 1.6628 4.76391 1.61036 4.85613 1.55516L4.85844 1.55378C4.95296 1.4972 5.04288 1.44338 5.12916 1.38855Z",
  fill: "#FDED80"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.111 19.316L16.3077 21.4649C16.2191 21.5211 16.1292 21.575 16.037 21.6302L16.0347 21.6315C15.9424 21.6867 15.8548 21.7392 15.7636 21.7906L14.5669 19.6417C14.6582 19.5903 14.7458 19.5379 14.838 19.4826L14.8403 19.4813C14.9348 19.4247 15.0248 19.3709 15.111 19.316Z",
  fill: "#FDED80"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.85876 0.311758L8.4782 2.70853C8.3786 2.73906 8.27832 2.76691 8.17546 2.79549L8.17289 2.7962C8.07003 2.82478 7.97231 2.85192 7.87133 2.87712L7.25189 0.480347C7.35287 0.455153 7.45059 0.428007 7.55344 0.399432L7.55602 0.398718C7.66145 0.369429 7.76174 0.34157 7.85876 0.311758Z",
  fill: "#FDED80"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.0274 20.3066L13.6468 22.7034C13.5472 22.7339 13.4469 22.7618 13.3441 22.7904L13.3415 22.7911C13.2386 22.8197 13.1409 22.8468 13.0399 22.872L12.4205 20.4752C12.5215 20.45 12.6192 20.4229 12.7221 20.3943L12.7246 20.3936C12.8301 20.3643 12.9303 20.3364 13.0274 20.3066Z",
  fill: "#FDED80"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.7618 3.16441L4.45414 4.91897C4.3826 4.99703 4.30919 5.07315 4.23389 5.15121L4.23201 5.15317C4.15671 5.23123 4.08518 5.30539 4.00988 5.37956L2.31754 3.625C2.39283 3.55084 2.46437 3.47667 2.53966 3.39861L2.54155 3.39665C2.61873 3.31664 2.69214 3.24052 2.7618 3.16441Z",
  fill: "#FDED80"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.8803 17.8001L18.5726 19.5547C18.5011 19.6328 18.4277 19.7089 18.3524 19.787L18.3505 19.7889C18.2752 19.867 18.2037 19.9411 18.1284 20.0153L16.436 18.2607C16.5113 18.1866 16.5829 18.1124 16.6582 18.0343L16.66 18.0324C16.7372 17.9524 16.8106 17.8763 16.8803 17.8001Z",
  fill: "#FDED80"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0.920248 5.51365L2.99293 6.75431C2.94333 6.84891 2.89141 6.94213 2.83817 7.03774L2.83684 7.04014C2.78359 7.13575 2.73301 7.22658 2.67879 7.31842L0.60611 6.07776C0.660328 5.98592 0.710909 5.89509 0.764153 5.79947L0.765484 5.79708C0.820059 5.69908 0.871972 5.60586 0.920248 5.51365Z",
  fill: "#FDED80"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.2105 15.8624L20.2832 17.1031C20.2335 17.1977 20.1816 17.2909 20.1284 17.3865L20.1271 17.3889C20.0738 17.4845 20.0232 17.5753 19.969 17.6672L17.8963 16.4265C17.9506 16.3347 18.0011 16.2438 18.0544 16.1482L18.0557 16.1458C18.1103 16.0478 18.1622 15.9546 18.2105 15.8624Z",
  fill: "#FDED80"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M-0.270648 8.27695L2.04113 8.91916C2.01683 9.02385 1.98996 9.12782 1.9624 9.23446L1.96171 9.23713C1.93415 9.34377 1.90797 9.44508 1.87852 9.54834L-0.433258 8.90613C-0.403814 8.80287 -0.377632 8.70156 -0.350071 8.59492L-0.349382 8.59225C-0.321132 8.48294 -0.294259 8.37897 -0.270648 8.27695Z",
  fill: "#FDED80"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.0153 13.6339L21.3271 14.2761C21.3028 14.3808 21.2759 14.4848 21.2483 14.5914L21.2477 14.5941C21.2201 14.7007 21.1939 14.802 21.1645 14.9053L18.8527 14.2631C18.8821 14.1598 18.9083 14.0585 18.9359 13.9519L18.9366 13.9492C18.9648 13.8399 18.9917 13.7359 19.0153 13.6339Z",
  fill: "#FDED80"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M-0.736237 11.2698L1.65709 11.2698C1.65976 11.3774 1.65976 11.4851 1.65976 11.5955L1.65976 11.5982C1.65976 11.7086 1.65976 11.8135 1.65709 11.9211L-0.736237 11.9211C-0.733574 11.8135 -0.733575 11.7086 -0.733575 11.5982L-0.733575 11.5955C-0.733575 11.4823 -0.733574 11.3746 -0.736237 11.2698Z",
  fill: "#FDED80"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.2315 11.27L21.6248 11.27C21.6275 11.3777 21.6275 11.4853 21.6275 11.5957L21.6275 11.5985C21.6275 11.7089 21.6275 11.8137 21.6248 11.9214L19.2315 11.9214C19.2342 11.8137 19.2342 11.7089 19.2342 11.5985L19.2342 11.5957C19.2342 11.4825 19.2342 11.3749 19.2315 11.27Z",
  fill: "#FDED80"
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M-0.431073 14.2728L1.88071 13.6306C1.91015 13.7338 1.93702 13.8378 1.96458 13.9445L1.96527 13.9471C1.99283 14.0538 2.01902 14.1551 2.04332 14.2598L-0.268463 14.902C-0.292764 14.7973 -0.318947 14.696 -0.346508 14.5893L-0.347197 14.5867C-0.375447 14.4774 -0.402319 14.3734 -0.431073 14.2728Z",
  fill: "#FDED80"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.8536 8.91953L21.1653 8.27731C21.1948 8.38057 21.2217 8.48455 21.2492 8.59119L21.2499 8.59386C21.2775 8.7005 21.3037 8.8018 21.328 8.90649L19.0162 9.54871C18.9919 9.44402 18.9657 9.34271 18.9381 9.23607L18.9374 9.2334C18.9092 9.12409 18.8823 9.02012 18.8536 8.91953Z",
  fill: "#FDED80"
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M0.606729 17.1072L2.67941 15.8665C2.73363 15.9583 2.78554 16.0516 2.83879 16.1472L2.84012 16.1496C2.89336 16.2452 2.94395 16.336 2.99355 16.4306L0.920868 17.6713C0.871261 17.5767 0.820679 17.4858 0.767435 17.3902L0.766103 17.3878C0.711528 17.2898 0.659616 17.1966 0.606729 17.1072Z",
  fill: "#FDED80"
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.8987 6.75804L19.9714 5.51738C20.0256 5.60922 20.0775 5.70244 20.1308 5.79805L20.1321 5.80044C20.1854 5.89605 20.2359 5.98688 20.2855 6.08148L18.2129 7.32214C18.1633 7.22754 18.1127 7.13671 18.0594 7.0411L18.0581 7.03871C18.0035 6.94071 17.9516 6.84749 17.8987 6.75804Z",
  fill: "#FDED80"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 11.4992,
  cy: 11.4998,
  r: 9.2,
  fill: "#FCD462"
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 11.4992,
  cy: 11.4998,
  r: 9.175,
  fill: "#F7CE46",
  stroke: "#F0AD00",
  strokeWidth: 0.05
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1_13170_4235)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_13170_4235)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.4999,
  cy: 11.5,
  r: 9.2,
  fill: "#F7CE46"
})));

var _ref31 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M32.5161 21.2155C32.5161 29.3188 26.746 35.8879 19.6282 35.8879C12.5104 35.8879 3.96442 30.905 3.96442 22.8017C3.96442 14.6983 14.2949 6.74133 21.4127 6.74133C28.5305 6.74133 32.5161 13.1121 32.5161 21.2155Z",
  fill: "#F6BF42",
  fillOpacity: 0.2
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter1_d_13170_4235)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7898 12.3419L8.14139 14.4371L11.7898 16.5324V12.3419Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7646 8.02234L8.11619 5.9275V10.1169L11.7646 8.02234Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7898 12.2556V8.0659L8.14139 10.16L11.7898 12.2556Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8643 12.2984L15.5124 14.3936V10.2031L11.8643 12.2984Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8391 8.06591V12.2556L15.4864 10.1604L11.8391 8.06591Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8391 16.5324L15.4872 14.4371L11.8391 12.3419V16.5324Z",
  fill: "#FFEAA0",
  stroke: "#F0AD00",
  strokeWidth: 0.05
}));

var _ref33 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_13170_4235",
  x: 2.29987,
  y: 2.30005,
  width: 18.45,
  height: 18.45,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 0.05,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_innerShadow_13170_4235"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.941176 0 0 0 0 0.772549 0 0 0 0 0.219608 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_13170_4235"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.941176 0 0 0 0 0.772549 0 0 0 0 0.219608 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_13170_4235",
  result: "effect2_innerShadow_13170_4235"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.941667 0 0 0 0 0.77127 0 0 0 0 0.219722 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_13170_4235",
  result: "effect3_innerShadow_13170_4235"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_13170_4235",
  x: 8.09119,
  y: 5.88428,
  width: 7.9462,
  height: 11.1913,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.87451 0 0 0 0 0.72549 0 0 0 0 0.243137 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13170_4235"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13170_4235",
  result: "shape"
})));

var SvgCoinDialog = function SvgCoinDialog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13170_4235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13170_4235)"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13170_4235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 19,
    height: 19
  }, _ref29), _ref30, _ref31), _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinDialog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CoinDialog.206f86df.svg";
export { ForwardRef as ReactComponent };